import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  ButtonV2,
  CloudDropdownButton,
  SearchBoxComponent,
} from '@labrav/react-components'
import { searchDropDownOptions } from '@labrav/common'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBadgeCheck } from '@fortawesome/pro-regular-svg-icons'
import { Typography } from '@mui/material'

import { useStyles } from './MarketplaceMultipleApn.styles'
import { cloudOptions } from './MarketplaceMultipleApn.constants'
import { MarketplaceMultipleApnHelpAndFaqData } from './helpAndFaq'
import { getCompleteOnboardingPath } from './MarketplaceMultipleApn.utils'
import { useMarketplaceMultipleApnAccess } from './useMarketplaceMultipleApnAccess'
import { useMarketplaceMultipleApnSearch } from './useMarketplaceMultipleApnSearch'
import { HelpFaqsSection } from './HelpFaqsSection'
import EmptyActivityLog from '../../images/EmptyActivityLog.png'
import { FlyoutBlockPage } from '../FlyoutBlockPage'
import { MarketplaceOnboardingPage } from '../MarketplaceOnboardingPage'

export const MarketplaceMultipleApn: React.FC = () => {
  const { classes } = useStyles()
  const navigate = useNavigate()
  const { isFlyoutSubscribed, isFlyoutOnboarded, activeProducts } =
    useMarketplaceMultipleApnAccess()
  const {
    searchNow,
    setSearchNow,
    showCrossMark,
    setShowCrossMark,
    inputValue,
    setInputValue,
    selectedOption,
    setSelectedOption,
    handleSearchClick,
  } = useMarketplaceMultipleApnSearch()

  const handleCompleteOnboarding = () => {
    navigate(getCompleteOnboardingPath(activeProducts))
  }

  const handleCloudSelect = () => {}

  if (!isFlyoutSubscribed) {
    return <FlyoutBlockPage showHeader={false} />
  }
  if (isFlyoutSubscribed && !isFlyoutOnboarded) {
    return (
      <MarketplaceOnboardingPage
        customButton={
          <>
            <ButtonV2
              styleType="primary"
              onClick={handleCompleteOnboarding}
              data-testid="continue-onboarding-button"
            >
              Continue onboarding
            </ButtonV2>
          </>
        }
      />
    )
  }
  return (
    <div
      className={classes.root}
      data-testid="marketplace-multiple-apn-container"
    >
      <div className={classes.leftContainer}>
        <div className={classes.topContainer}>
          <div>
            <SearchBoxComponent
              options={searchDropDownOptions.multipleApnOptions}
              handleSearchClick={handleSearchClick}
              loading={false}
              searchNow={searchNow}
              setSearchNow={setSearchNow}
              showCrossMark={showCrossMark}
              setShowCrossMark={setShowCrossMark}
              inputValue={inputValue}
              setInputValue={setInputValue}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              disabled={true}
            />
          </div>
          <div>
            <CloudDropdownButton
              buttonText={'Add new cloud account'}
              disabled={false}
              cloudOptions={cloudOptions}
              onCloudSelect={handleCloudSelect}
              menuWidth={72}
            />
          </div>
        </div>
        <div className={classes.bottomContainer}></div>
      </div>
      <div className={classes.rightContainer}>
        <div className={classes.helpContainer}>
          <HelpFaqsSection
            title={''}
            content={MarketplaceMultipleApnHelpAndFaqData.marketPlace.content}
          />
        </div>

        <div className={classes.activityLogContainer}>
          <div className={classes.titleContainer}>
            <FontAwesomeIcon
              icon={faBadgeCheck}
              style={{ width: '18px', height: '14px' }}
            />
            <Typography className={classes.heading} data-testid="box-heading">
              Activity log
            </Typography>
          </div>
          <div className={classes.svgBackground}>
            <img
              src={EmptyActivityLog}
              alt="Labra Icon"
              className={classes.labraIcon}
            />
            <div className={classes.activityHeading}>
              Activities will appear here
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
